import React, { useState, useEffect, useCallback } from "react";
import Styled from "styled-components";
import { useId, Listbox, ListboxPopover, ListboxList, ListboxButton, ListboxOption, } from "@vp/swan";
import { SimpleTitle } from "../../../../../shared/simple-title";
import { ListboxPlaceholder } from "../../../../dropdown-options/components/option-skins/shared/listbox-placeholder";
import { decodeKey, encodeKey } from "../../../../dropdown-options/helpers";
import { useProductOptionsFeaturesContext } from "../../../../../contexts/product-options-features";
import { getQuantityItemFlags } from "./get-quantity-item-flags";
import { QuantityItem } from "./quantity-item";
/**
 * This is a fix for the listbox not being able to handle complex
 * children in the label prop.
 *
 * The Listbox button is a flex container, but it doesn't stretch
 * its children to fill the width.
 */
const TightQuantityListboxFix = Styled.div `
  .swan-listbox-full-width {
    > button {
      flex-direction: column;
      align-items: stretch;

      > span {
        display: flex;
        flex-direction: column;
        align-items: stretch;
      }
    }
  }
`;
const SnowflakeLayout = ({ children }) => {
    const { disableSwanSnowflakes } = useProductOptionsFeaturesContext();
    if (disableSwanSnowflakes) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(TightQuantityListboxFix, null, children);
};
export const QuantityDropdown = ({ option, locale, currency, fractionDigits, onChanged, showIncompatibleChoices, savingsFormat = "percent", priceDisplayMode, hasSampleQuantity = false, tenant, }) => {
    const titleId = useId();
    const [selectedChoiceKey, setSelectedChoiceKey] = useState(option.selectedKey);
    useEffect(() => {
        // By storing the selection in state and updating it whe the prop changes, we
        // fix an a11y issue that prevents the radiogroup from being navigable with arrow
        // keys, but also keeps the current selection in perfect sync with the keyboard focus.
        setSelectedChoiceKey(option.selectedKey);
    }, [option.selectedKey]);
    const handleOnChange = useCallback((value) => {
        const decodedValue = decodeKey(value);
        if (!decodedValue) {
            return; // prevent unselecting a quantity
        }
        onChanged({ choiceKey: decodedValue });
    }, []);
    return (React.createElement(SnowflakeLayout, null,
        React.createElement(SimpleTitle, { titleId: titleId }),
        React.createElement(Listbox, { selectionMode: "single", fullWidth: true, mt: "4", value: encodeKey(selectedChoiceKey) ?? "", onChange: handleOnChange, "aria-labelledby": titleId },
            React.createElement(ListboxButton, { placeholder: React.createElement(ListboxPlaceholder, null) }),
            React.createElement(ListboxPopover, null,
                React.createElement(ListboxList, null, option.choices
                    .filter((choice) => showIncompatibleChoices || choice.isCompatible)
                    .map((choice, index) => {
                    const { quantitySavingsIsVisible, isSampleQuantity } = getQuantityItemFlags(savingsFormat, hasSampleQuantity, index);
                    const onSale = (choice.totalDiscountedPrice ?? 0) < (choice.totalListPrice ?? 0);
                    const Label = () => (React.createElement(QuantityItem, { choice: choice, priceDisplayMode: priceDisplayMode ?? "none", locale: locale, fractionDigits: fractionDigits, currency: currency, isSampleQuantity: isSampleQuantity ?? false, quantitySavingsIsVisible: quantitySavingsIsVisible, savingsFormat: savingsFormat, onSale: onSale }));
                    return (React.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, label: React.createElement(Label, null) },
                        React.createElement(Label, null)));
                }))))));
};
//# sourceMappingURL=quantity-dropdown.js.map